<template>
  <div class="news-item-container">
    <div class="row news-item-container-title">
      <span class="title-related-news">
        <!-- <span class="title" @click="onCheckDetailClick(data.newsId)">{{data.title}}</span> -->
        <a v-if="!data.is_pdf" target="_blank" class="title" :href="data.url">{{data.title}}</a>
        <router-link @click.native="toPdfPage" class="title" v-else target="_blank" :to="{path: '/pdf-detail'}">
          <span>{{data.title}}</span>
        </router-link>
        <span v-if="data.count > 0" @click="onEmitNewsId(data.newsId)" class="related-news"><span class="related-news-icon"></span>相关文章</span>
      </span>
      <div class="row date-source">
        <div class="date">{{data.date}}</div>
        <div class="source">{{data.source}}</div>
      </div> 
    </div>
    <div v-if="data.persons.length">
      <div v-for="(item, index) in data.persons" :key="index">
        <div v-if="(!showMore && index===0) || showCompany">
          <span @click="toCompanyDetail(item.person_name)" class="company-name">
            <div class="important-company-img"></div>
            <span>{{item.person_name}}</span>
          </span>
          <div class="every-box row" :class="{'hidden-clues': !showClues}" v-for="(items, idx) in item.labels" :key="idx">
            <div v-show="showClues" class="tag-name"><span :class="{'hidden-clues-tag-name': !showClues, positive: items.sentiment === '正面', negative: items.sentiment === '负面', neutral: items.sentiment === '中性'}">{{items.sentiment}}</span></div>
            <div class="thread-content" v-if="showClues" :class="{ 'positive-content': items.tagType === 'positive', 'negative-content': items.tagType === 'negative'}">
              <span v-for="(thread, i) in items.hints" :key="i">
                <img v-if="items.sentiment === '正面'" class="index" :src="require('../../assets/img/positive-div.svg')" alt=""> 
                <img v-if="items.sentiment === '负面'" class="index" :src="require('../../assets/img/negative-div.svg')" alt=""> 
                <img v-if="items.sentiment === '中性'" class="index" :src="require('../../assets/img/neutral-div.svg')" alt=""> 
                <span>{{thread.replace(/(^\s*)|(\s*$)/g,"")}} </span>
              </span>
            </div>
          </div>
        </div>
      </div>
     </div>
    <div v-if="!showMore && data.persons.length > 1" @click="showMore = true" class="show-more">展开更多<img class="arrow-img" src="../../assets/img/down-arrow.svg" alt=""></div>
    <div v-if="showMore && data.persons.length > 1" @click="showMore = false" class="show-more">收起<img class="arrow-img" src="../../assets/img/up-arrow.svg" alt=""></div>

    <div class="news-dialog">
      <el-dialog
        :visible.sync="similarityDialogVisible"
        :modal="modal"
        :append-to-body="appendToBody"
        width="814px"
        >
        <div class="news-dialog_title">相关新闻<span class="news-dialog_title-count">({{similarityTotalCount}}条)</span></div>
        <div class="similarity-news-list-box">
          <similarity-news-list-item v-for="(item, idx) in similarityResultData" :data="item" :key="idx"></similarity-news-list-item>
          <div class="no-data-container" v-if="!similarityTotalCount">
            <no-data></no-data>
          </div>
        </div>  
      </el-dialog>
    </div>
  </div>
</template>

<script>
import QuestionQuery from '@/rest/questionQuery';
import Mark from 'mark.js';
import SimilarityNewsListItem from '@/components/news-monitor/SimilarityNewsListItem';
import NoData from '@/components/common/NoData';
import localStorageHelper from '@/helpers/localStorageHelper';

export default {
  name: 'news-list-item',
  props: {
    data: {
      type: Object,
      required: true
    },
    showClues: {
      type: Boolean,
      default: true
    },
    modal: {
      default: true
    },
    searchText: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMore: false,
      dialogVisible: false,
      title: '',
      date: '',
      source: '',
      detail: '',
      url: '',
      instance: '',
      negativeHeight: [],
      positiveHeight: [],
      switchStatus: true,
      similarityDialogVisible: false,
      similarityTotalCount: 0,
      similarityResultData: [],
      pdfTextData: {
        pdf: [],
        text: []
      },
      noEvidenceData: false,
      isLoadingEvidence: false
    };
  },
  computed: {
    showCompany() {
      if (this.showMore && this.data.persons.length) {
        return true;
        // eslint-disable-next-line
      } else {
        return false;
      }
    }
  },
  methods: {
    toPdfPage() {
      localStorageHelper.setItem('PDF_DETAIL_DATA', JSON.stringify(this.data));
    },
    onShowEvidence(searchText, companyName, relation) {
      this.pdfTextData = {
        pdf: [],
        text: []
      };
      this.noEvidenceData = false;
      this.isLoadingEvidence = true;
      QuestionQuery.getCompanyRefer(searchText, companyName, relation).then(res => {
        this.isLoadingEvidence = false;
        this.noEvidenceData = true;
        this.pdfTextData = res;
      });
    },
    toCompanyDetail(res) {
      const routeUrl = this.$router.resolve({
        path: '/person', 
        query: {
          q: res
        }  
      });
      window.open(routeUrl.href, '_blank');
      // this.$router.push({
      //   name: 'result-page',
      //   query: {
      //     q: res
      //   }
      // });
    },
    onEmitNewsId(newsId) {
      this.similarityDialogVisible = true;
      QuestionQuery.similarityNewsList(newsId).then(result => {
        this.similarityTotalCount = result.totalCount;
        this.similarityResultData = result.pageItems;
      });
    },
    onCheckDetailClick(id) {
      QuestionQuery.getNewsDetail(id).then(res => {
        const a = document.createElement('a');
        a.setAttribute('href', res.url);
        a.setAttribute('target', '_blank');
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // this.dialogVisible = true;
        // this.title = res.title;
        // this.date = res.date;
        // this.source = res.source;
        // this.detail = res.detail;
        // this.url = res.url;
        // this.negativeHeight = res['negative-height'];
        // this.positiveHeight = res['positive-height'];
      });
    }
  },
  components: {
    NoData,
    SimilarityNewsListItem
  },
  updated() {
    const instance = new Mark(document.querySelectorAll('.detail-dialog-content'));
    instance.mark(this.positiveHeight || [], {
      element: 'span',
      className: 'positive-height'
    });
    instance.mark(this.negativeHeight || [], {
      element: 'span',
      className: 'negative-height'
    });
  }
};
</script>

<style lang="scss" scoped>
.risk-title{
    height: 20px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #36c292;
}
 .risk-title.positive{
    font-size: 14px;
    letter-spacing: 0px;
    color: #dc5057;
  }
  .risk-title.negative{
    font-size: 14px;
    letter-spacing: 0px;
    color: #36c292;
  }
  .risk-text{
    border-left: 2px solid #36c292;
    margin-top: 8px;
    padding-left: 8px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: #464d6c;
  }
  .risk-text.positive{
    border-left: 2px solid #dc5057;
  }
.news-item-container {
  padding: 16px 0 10px;
  box-shadow: inset 0px -1px 0px 0px#f7f7fa;
  // box-shadow: inset 0px -1px 0px 0px #514e52;
  // border-bottom: 1px solid #e8e8e8;
  .news-item-container-title {
    justify-content: space-between;
    line-height: 22px;
    .related-news-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right:2px;
      vertical-align: middle;
      background-image: url("../../assets/img/related-news.svg");
      background-size: cover;
    }
    .related-news {
      margin-left: 16px;
      font-size: 12px;
      color: #45a8cc;
      cursor: pointer;
      &:hover {
        color:#3cbeed;
        font-weight: bold;
      }
      &:active {
        color: #45a8cc;
        font-weight: bold;
      }
    }
    .title-related-news {
      width: 750px;
    }
    .title {
      display: inline-block;
      min-height: 22px;
      margin-bottom: 6px;
      color: #171F46;
      font-size: 16px;
      font-weight: 500;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .date-source {
    margin-left: 20px;
    color: #747990;
    font-size: 12px;
    .source {
      margin-left: 16px;
      max-width: 108px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .company-name {
    position: relative;
    z-index: 1;
    display: inline-block;
    margin-right: 10px;
    margin-top: 10px;
    margin-bottom: 6px;
    line-height: 16px;
    padding: 2px 8px;
    border-radius: 2px;
    background:#f7f8fc;
    color: #464D6C;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    &:hover{
      background-image: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05)), 
      linear-gradient(#f7f8fc, #f7f8fc);
      background-blend-mode: normal, normal;
    }
    .important-company-img {
      display: inline-block;
      margin-bottom: -3px;
      margin-right: 5px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background: url("../../assets/img/person-icon.svg") no-repeat;
      background-size: cover;
    }
  }
  .previewer-name {
    margin-left: 8px;
    color:rgba(121,199,212,1);
    font-weight: 500;
  }
  .hidden-clues {
    display: inline-block;
  }
  .hidden-clues-tag-name {
    display: inline;
  }
  .tag-name{
    height: 20px;
    border-radius: 2px;
    color: #fff;
    padding: 2px 4px;
    font-size: 12px;
    margin-right: 10px;
  }
   .every-box{
    // margin-top: 18px;
    position: relative;
    .tag-name {
      width: 90px;
      padding-top: 8px;
      margin-right: 0;
      // margin: 6px 10px 0 0;
      // padding: 2px 8px;
      // font-size: 12px;
      // height: 22px;
      // border-radius: 2px;
    }
  }
 
  .positive {
    margin: 6px 10px 0 0;
    padding: 1px 8px;
    font-size: 12px;
    height: 22px;
    border-radius: 2px;
    border: 1px solid rgba(220,80,87,.5);
    color: #dc5057;
  }
  .negative {
    margin: 6px 10px 0 0;
    padding: 1px 8px;
    font-size: 12px;
    height: 22px;
    border-radius: 2px;
    border: 1px solid rgba(49,175,132,.5);
    color: #31af84;
  }
  .neutral {
    margin: 6px 10px 0 0;
    padding: 1px 8px;
    font-size: 12px;
    height: 22px;
    border-radius: 2px;
    border: 1px solid rgba(116, 121, 144, 0.7);
    color: #464d6c;
  }
  .index {
    position: relative;
    top: 2px;
    margin-right: 4px;
    text-align: center;
  }
  .thread {
    margin-right: 12px;
  }
 
  .thread-content {
    flex: 1;
    // margin-top: 6px;
    line-height: 20px;
    color: #464D6C;
    font-size: 13px;
    letter-spacing: 0.3px;
    padding: 6px;
  }
  .positive-content{
    border-radius: 2px;
    // border: solid 1px rgba($color: #ffa5aa, $alpha: .2);
  }
  .negative-content{
    border-radius: 2px;
    // border: solid 1px rgba($color: #36c292, $alpha: .2);
  }
  .show-more {
    margin-top: 10px;
    margin-bottom: 6px;
    color: #464D6C;
    font-size: 12px;
    cursor: pointer;
    .arrow-img {
      width: 16px;
      vertical-align: middle;
    }
  }
}
/deep/.detail-dialog {
  .detail-dialog-header {
    padding: 32px 32px 26px;
    min-height: 114px;
    width: 100%;
    background-color: #f7f8fc;
    .title {
      margin-bottom: 12px;
      color: #171f46;
      font-size: 20px;
      font-weight: 500;
    }
    .dialog-date-source {
      line-height: 20px;
      justify-content: space-between;
      color: #747990;
      font-size: 12px;
      font-weight: 500;
      .source {
        margin-left: 16px;
      }
      .switch-title {
        margin-left: 8px;
        color: #464d6c;
      }
    }
  }
  .detail-dialog-content {
    padding: 24px 32px;
    height: 496px;
    overflow: auto;
    color: #464d6c;
    font-size:14px;
    line-height: 22px;
    background-color: #ffffff !important;
  }
  .detail-dialog-content-highlight span.positive-height{
    color: #464d6c !important;
  }
  .detail-dialog-content-highlight span.negative-height{
    color: #464d6c !important;
  }
  .detail-dialog-footer {
    padding: 16px 32px;
    background-color: #f7f8fc;
    .url {
      color: #45a8cc;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
    }
    .warning {
      margin-top: 4px;
      color: #747990;
      font-size: 12px;
    }
  }
  .el-dialog {
    background-color: #ffffff;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      min-height: 680px;
      padding: 0;
    }
    .el-dialog__footer {
      padding: 0px;
    }
  }
}
/deep/{
  .el-switch__core {
    width: 34px !important;
  }
  .el-switch__core:after {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: #e4e4e4;
  }
  .el-switch.is-checked .el-switch__core::after {
    margin-left: -14px;
  }
}

.news-dialog {
  &_title {
    height: 44px;
    line-height: 44px;
    padding-left: 24px;
    font-size: 14px;
    font-weight: 500;
    color: #171F46;
    box-shadow:0px 1px 0px 0px rgba(247,247,250,1);
  }
  .similarity-news-list-box {
    height: 656px;
    overflow-y: auto;
    .no-data-container {
      height: 500px;
    }
  }
  /deep/ .el-dialog__wrapper {
    // z-index: 9999 !important;
    background: rgba(0,0,0,0.4);
    .el-dialog {
      width: 900px;
      position: relative;
      margin-top: 13vh !important;
      border-radius: 8px;
      border: solid 1px #3e393b;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 12px;
          .el-dialog__close {
            color: #514d4f;
          }
        }
      }
      .el-dialog__body {
        background: #ffffff;
        padding: 0;
        .search-news-list-container {
          .filter {
            height: 54px;
            justify-content: center;
            span {
              display: none;
            }
            div{
              display: none;
            }
            border-bottom: 1px solid #4E4A4D;
            padding-bottom: 22px;
          }
          .result-container {
          height: 60vh;
          overflow-y: auto;
          margin-top: 0;
          // &::-webkit-scrollbar-track-piece {
          //   background-color: rgba(0, 0, 0, 0);
          //   border-left: 1px solid rgba(0, 0, 0, 0);
          // }
          // &::-webkit-scrollbar {
          //   width: 8px;
          //   height: 34px;
          // }
          // &::-webkit-scrollbar-thumb {
          //   background-color: #676366;
          //   background-clip: padding-box;
          //   min-height: 28px;
          // }
          // &::-webkit-scrollbar-thumb:hover {
          //   background-color: #999999;
          // }
            .news-list-header {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-dialog__wrapper {
    // z-index: 9999 !important;
    background: rgba(0,0,0,0.4);
    .el-dialog {
      width: 900px;
      position: relative;
      // margin-top: 13vh !important;
      border-radius: 4px !important;
      box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.2) !important;
      border: none;
      overflow: hidden;
      .el-dialog__header {
        position: absolute;
        top: 0;
        right: 0px;
        .el-dialog__headerbtn {
          width: 24px;
          height: 24px;
          top: 12px;
          .el-dialog__close {
            color: #514d4f;
          }
        }
      }
      .el-dialog__body {
        background: #ffffff;
        padding: 0;
        &_title {
          height: 44px;
          line-height: 44px;
          padding-left: 24px;
          font-size: 14px;
          font-weight: 500;
          color: #171F46;
          box-shadow:0px 1px 0px 0px rgba(247,247,250,1);
        }
        .similarity-news-list-box {
          height: 556px;
          overflow-y: auto;
          .no-data-container {
            height: 500px;
          }
        }
        .search-news-list-container {
          .filter {
            height: 54px;
            justify-content: center;
            span {
              display: none;
            }
            div{
              display: none;
            }
            border-bottom: 1px solid #4E4A4D;
            padding-bottom: 22px;
          }
          .result-container {
          height: 60vh;
          overflow-y: auto;
          margin-top: 0;
          .news-list-header {
            display: none;
          }
          }
        }
      }
    }
  }


.detail-dialog-content.content a {
  color: #45a8cc !important;
}
.detail-dialog-content.content a span {
  color: #45a8cc !important;
}
/* .detail-dialog-content.content p {
  color: #ffffff !important;
  background-color: #333138 !important;
} */
.detail-dialog-content.content img {
  max-width: 100% !important;
}
.detail-dialog-content.content video {
  max-width: 100% !important;
}

.el-popover.img-previewer {
  height: 400px;
  width: 400px;
  overflow: auto;
  background-color: #fff;
  box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
  border-radius:2px;
  border:2px solid rgba(69,168,204,1);
  padding: 0;
  .content-container {
    .evidence-loading {
      height: 400px;
      width: 100%;
    }
    .content-container-pdf {
      .content-container-pdf-item {
        padding: 10px 0;
        box-shadow: inset 0px -1px 0px 0px#f7f7fa;
        .pdf-title {
          margin-left: 10px;
          color: rgba(69, 168, 204, 1);
          font-weight: 600;
          font-size: 12px;
        }
        .pdf-img {
          img {
            max-width: 362px;
          }
        }
        // .big-img {
        //   display: block;
        //   margin: 0 auto;
        //   max-width: 352px !important;
        //   max-height: 109px !important;
        // }
      }
    }
    .content-container-content-item {
      padding: 10px 0;
      box-shadow: inset 0px -1px 0px 0px#f7f7fa;
      .check-original-btn {
        color: #45a8cc;
        font-size: 12px;
        text-decoration: none;
      }
    }
    .no-compant-evidence-container {
      position: relative;
      height: 333px;
      .no-compant-evidence {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 123px;
      }
      .no-compant-evidence-data {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 196px;
        color: #9ea1b4;
        font-size: 14px;
      }
    }
  }
}
.el-popover.el-popper{
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1) ;
    -webkit-box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1) ;
    border: solid 1px #f7f7fa ;
    padding: 16px ;
    background-color: #ffffff ;
}
.el-popover.el-popper.company-tip {
  width: 3px;
  height: 4px;
  color: transparent;
  border: none;
  font-size: 12px;
  background-color: transparent;
  box-shadow: none;
  /deep/.important-company-popover {
    position: relative;
    top: -20px;
    left: -5px;
    width: 56px;
    height: 26px;
    background-color: #3d414f;
    border-radius: 2px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
    color: #ffffff;
    padding: 4px;
  }
}
.el-popover.pdf-img-previewer {
  box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
  .content-container {
    .big-img {
      display: block;
      margin: 0 auto;
      max-width: 700px !important;
      max-height: 399px !important;
    }
  }
}
</style>
